import React, { useEffect } from "react";
import {
  formatStakeBalance,
  getPackageIcon,
  getStakingTypeLabel,
  getUnbondingPeriodDays,
} from "./stakingStakeHelpers";
import "./staking.css";

const OverviewRow = ({ label, value, highlight }) => (
  <div className="stake-overview-row">
    <span className="stake-overview-row__label">{label}</span>
    <span className={`stake-overview-row__value${highlight ? " stake-overview-row__value--green" : ""}`}>
      {value}
    </span>
  </div>
);

const RedeemConfirmOverview = ({
  selectedPackage,
  redeemAmount,
  availableAmount,
  currency,
  timeRedeemed,
  timeReceived,
  loading = false,
  error = "",
  onBack,
  onConfirm,
}) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && !loading) onBack?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onBack, loading]);

  if (!selectedPackage) return null;

  const currencyFullName = selectedPackage.currencyFullName || selectedPackage.fullName || selectedPackage.coinName || "—";
  const stakingType = getStakingTypeLabel(selectedPackage.stakingType);
  const unbondingDays = getUnbondingPeriodDays(selectedPackage);
  const afterRedeem = Math.max(Number(availableAmount) - Number(redeemAmount), 0);

  return (
    <div className="stake-overview-overlay" onClick={loading ? undefined : onBack}>
      <div className="stake-overview-content" onClick={(e) => e.stopPropagation()}>
        <div className="stake-overview-header">
          <div className="stake-overview-header__left">
            <div className="stake-overview-title">
              <img
                src={getPackageIcon(selectedPackage)}
                alt={currency}
                className="mint-title-icon"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `/images/staking_img/${String(currency || "usdt").toLowerCase()}_icon.svg`;
                }}
              />
              <span>{currency ? `${currency} ` : ""}Redeem Overview</span>
            </div>
          </div>
          <button type="button" className="mint-modal-close" disabled={loading} onClick={onBack}>
            <i className="ri-close-line" />
          </button>
        </div>

        <p className="stake-overview-subtitle">
          Please review your redemption details before confirming.
        </p>

        <div className="stake-overview-body">
          <OverviewRow label="Currency" value={currency || "—"} />
          <OverviewRow label="Currency Name" value={currencyFullName} />
          <OverviewRow label="Staking Type" value={stakingType} />
          <OverviewRow
            label="Redeem Amount"
            value={`${formatStakeBalance(redeemAmount)} ${currency}`}
            highlight
          />
          <OverviewRow
            label="Available"
            value={`${formatStakeBalance(availableAmount)} ${currency}`}
          />
          <OverviewRow
            label="After Redeem"
            value={`${formatStakeBalance(afterRedeem)} ${currency}`}
            highlight
          />
          <OverviewRow label="Time Redeemed" value={timeRedeemed} />
          <OverviewRow label="Time Received" value={timeReceived} highlight />
          <OverviewRow
            label="Unbonding Period"
            value={`About ${unbondingDays} day(s)`}
          />
        </div>

        {error ? <div className="stake-overview-error">{error}</div> : null}

        <div className="stake-overview-actions">
          <button type="button" className="mint-btn-cancel" disabled={loading} onClick={onBack}>
            Back
          </button>
          <button
            type="button"
            className="mint-btn-confirm"
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? "Processing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RedeemConfirmOverview;
